import { render, staticRenderFns } from "./children.vue?vue&type=template&id=e72c314e&scoped=true&"
import script from "./children.vue?vue&type=script&lang=js&"
export * from "./children.vue?vue&type=script&lang=js&"
import style0 from "./children.vue?vue&type=style&index=0&id=e72c314e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72c314e",
  null
  
)

export default component.exports